import React, {Component} from 'react';
import {Header, Icon} from "semantic-ui-react";
import Footer from "./footer";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization} from "../utils/localization";
import {CustomGrid} from "./custom-common";
import {isAssociationContract} from "../utils/common";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData} = state;
    return {
        lang: user.lang,
        contractType: initialData.contractType,
        ...ownProps
    }
};

class NotEligible extends Component {
    componentDidMount() {
        window.onbeforeunload = null;
    }

    render() {
        const localization = getLocalization(this.props.lang);
        const strings = localization.notEligible;
        const isAssociation = isAssociationContract(this.props.contractType);

        return (
            <React.Fragment>
                <CustomGrid container stackable columns={1} centered>
                    <CustomGrid.Row>
                        <CustomGrid.Column textAlign='center' width={6} style={{marginTop: '10em'}}>
                            <div>
                                <Icon style={{boxShadow: 'none'}} className={'warningIconRounded'} name={'warning sign'} circular size={'big'}/>
                            </div>
                            <Header as={'h4'} className='neutral900Text'>{strings.eligibilityIssue}</Header>
                            <p>
                                {isAssociation ? strings.basedOnTheAssociation : strings.basedOnThe}
                            </p>
                        </CustomGrid.Column>
                    </CustomGrid.Row>
                </CustomGrid>
                <Footer showTopFooter={false} showCenterData={true} hideLimitationsAndExclusions={true}/>
            </React.Fragment>
        );
    }
}

export default withRouter(connect(mapStateToProps)(NotEligible));
